import axios, { getData } from "lib/axios"

export const getNumDays = () => {
    return axios.get(`admin/working-days`).then(getData);
}

export const postNumDays = (data) => {
    return axios.post(`admin/working-days-insert`, data);
}